import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { initVendors } from './lib/vendor';

// The server (static index.html or SSR job-template.html) always ships one
// <meta name="description">. react-helmet-async never removes tags it didn't
// create, so once a page renders its own <Helmet> description this static one
// would stay behind it, producing 2 description tags in the final DOM.
document.querySelectorAll('meta[name="description"]:not([data-rh])').forEach(el => el.remove());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><HelmetProvider><App /></HelmetProvider></React.StrictMode>);

initVendors();
